import React, { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  DesktopThumbnailGalleryContainer, MainImage,
  MainImageContainer, Thumbnail, ThumbnailsGrid
} from 'components/PdpImageGallery/styled';
import { useProductLivePreview } from '../../features/pdp/hooks/useProductLivePreview';
import { DESKTOP_PRIMARY_IMAGE_INDEX, LIVE_PREVIEW_DESKTOP_INDEX, VIDEO_TYPE } from 'constants/pdp';
import { PDPMediaObject, renderVideo } from 'components/PdpImageGallery/helpers';
import VideoIcon from '../../icons/Video.svg';
import { ImageGalleryProps } from 'components/PdpImageGallery/MobileImageGallery';

//TODO: rename to DesktopImageGallery if this test wins and we are able to remove the other desktop gallery

const DesktopImageGalleryThumbnailView: React.FC<ImageGalleryProps> = ({ photos, onImageClick }) => {
  const [selectedImage, setSelectedImage] = useState(photos[DESKTOP_PRIMARY_IMAGE_INDEX]);
  const livePreviewUrl = useProductLivePreview();
  const { formState: { isDirty } } = useFormContext();

  useEffect(() => {
    if (isDirty && livePreviewUrl) {
      setSelectedImage(photos[LIVE_PREVIEW_DESKTOP_INDEX]);
    }
  }, [isDirty, livePreviewUrl, photos]);

  const mainContent = useMemo(() => {
    if (selectedImage.type === VIDEO_TYPE) {
      const video = selectedImage as PDPMediaObject;
      video.isMobile = false;
      return renderVideo(video);
    }
    return (
      <MainImage
        src={selectedImage.full}
        alt="Selected"
        onClick={() => onImageClick?.(selectedImage.full)}
      />
    );
  }, [selectedImage, onImageClick]);


  return (
    <DesktopThumbnailGalleryContainer>
      <MainImageContainer>
        {mainContent}
      </MainImageContainer>

      <ThumbnailsGrid>
        {photos.map((img, idx) => {
          if (!img || typeof img !== 'object') {
            console.warn(`Skipping photo at index ${idx}: invalid image object`, img);
            return null;
          }

          const hasThumb = typeof img.thumb === 'string' && img.thumb.length > 0;
          const isVideo = img.type === VIDEO_TYPE && img.videoUrl;
          const imageSrc = !isVideo ? img.thumb : VideoIcon;
          const altText = hasThumb
            ? `Thumbnail ${idx + 1}`
            : `Fallback thumbnail for video ${idx + 1}`;

          return (
            <Thumbnail
              key={idx}
              onClick={() => setSelectedImage(img)}
              isActive={selectedImage === img}
            >
              <img
                src={imageSrc}
                alt={altText}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </Thumbnail>
          );
        })}
      </ThumbnailsGrid>

    </DesktopThumbnailGalleryContainer>
  );
};

export default DesktopImageGalleryThumbnailView;